import React from 'react';
import ChevronLeftIcon from 'material-ui/svg-icons/navigation/chevron-left';
import Button from '@material-ui/core/Button';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import './ScorecardOverrideNav.styl';
import connectToStores from 'alt-utils/lib/connectToStores';
import ScorecardQuestionnaireStore from 'stores/scorecards/ScorecardQuestionnaireStore';

export const overrideName = 'ScorecardOverride';

@connectToStores
export default class ScorecardOverrideNav extends React.PureComponent {
  static getStores() {
    return [ScorecardQuestionnaireStore];
  }

  static getPropsFromStores() {
    return {
      // Changes to answers can change form validity.
      // Use these to force rerender on answer changes so we can pick up changes to the submit
      // button (if it's visible).
      answers: ScorecardQuestionnaireStore.getState().get('answers'), // it's a map.
    };
  }

  render() {
    if (!this.props) return;

    const {name, goBack, goToChooser, submit, cancel, disableSubmit, hasMultipleScorecards} =
      this.props;

    return (
      <div className="scorecard-override-header">
        <div className="wrapper">
          <Button
            variant="text"
            className="ev-button"
            onClick={hasMultipleScorecards ? goToChooser : goBack}>
            <ChevronLeftIcon />
            {hasMultipleScorecards ? 'Back To Scorecards' : 'Back To Call'}
          </Button>
          <header>{name}</header>
          <div className="actions">
            <Button variant="outlined" className="ev-button" onClick={() => cancel()}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="ev-button"
              icon={<CheckIcon className="icon check" />}
              onClick={() => submit()}
              disabled={disableSubmit()}>
              Save
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
